export const isInternalUser = (): boolean => {
  // @ts-expect-error - TS2339 - Property 'senseStore' does not exist on type 'Window & typeof globalThis'.
  const state = window.senseStore.reduxStore.getState();
  const {accounts} = state;
  if (accounts) {
    const {authedUserId} = accounts;
    if (accounts && authedUserId) {
      const userInfo = accounts.data[authedUserId];
      const {email} = userInfo;
      // return /admin_.*@sensehq/.test(email);
      return /.*@sensehq/.test(email);
    }
  }
  return false;
};
